import httpClient, {
  ApiResponseType,
  CreateResourceSuccessResponseType,
  FORM_DATA_CONFIG,
} from '../../http_client';
import {
  GetIncentiveAgreement,
  GetIncentiveAgreementResponse,
  UpdateCreateIncentiveAgreementType,
  UpdateIncentiveAgreementResponse,
} from '../types';
import { convertIncentiveAgreementBody, TECHNICALLICENSE_INCENTIVE_AGREEMENT } from '../utils';

const getTechnicalLicenseIncentiveAgreementByIdApi = (id: number) => {
  const url = `${TECHNICALLICENSE_INCENTIVE_AGREEMENT}/${id}`;
  return httpClient.get<ApiResponseType<GetIncentiveAgreement>>(url);
}

const createTechnicalLicenseIncentiveAgreementApi = (data: UpdateCreateIncentiveAgreementType) => {
  const url = TECHNICALLICENSE_INCENTIVE_AGREEMENT;
  const body = convertIncentiveAgreementBody(data);
  return httpClient.post<ApiResponseType<CreateResourceSuccessResponseType>>(url, body, FORM_DATA_CONFIG);
}

const updateTechnicalLicenseIncentiveAgreementApi = (data: UpdateCreateIncentiveAgreementType, id: number) => {
  const url = `${TECHNICALLICENSE_INCENTIVE_AGREEMENT}/${id}`;
  const body = convertIncentiveAgreementBody(data);
  return httpClient.put<ApiResponseType<UpdateIncentiveAgreementResponse>>(url, body, FORM_DATA_CONFIG);
}

export const getTechnicalLicenseIncentiveAgreementById = async (id: number): Promise<GetIncentiveAgreementResponse> => {
  const response = await getTechnicalLicenseIncentiveAgreementByIdApi(id);
  const { data, error, httpStatus } = response;
  return { error, httpStatus, data: data?.result };
}

export const createTechnicalLicenseIncentiveAgreement = async (data: UpdateCreateIncentiveAgreementType):
    Promise<ApiResponseType<CreateResourceSuccessResponseType>> => {
  const response = await createTechnicalLicenseIncentiveAgreementApi(data);
  const { error, httpStatus } = response;
  return { error, httpStatus };
}

export const updateTechnicalLicenseIncentiveAgreement = async (payload: UpdateCreateIncentiveAgreementType, id: number):
    Promise<ApiResponseType<CreateResourceSuccessResponseType>> => {
  const response = await updateTechnicalLicenseIncentiveAgreementApi(payload, id);
  const { error, httpStatus } = response;
  return { error, httpStatus };
}
